import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { AutoComplete } from 'antd'

const { Option } = AutoComplete

@observer
class AddAddress extends Component {

  refsArr = {
    streetTemplate: null,
    buildingTemplate: null,
    homeTemplate: null,
    templateInfo: null,
    addBtn: null,
  }

  onStreetSelect = (value, option) => {
    this.props.setStreet(option.props.streetid, option.props.streettype === 1 ? true : false, option.props.iter, option.props.label)
    this.refsArr[option.props.nextFocus].focus()
  }

  onStreetSearch = (searchText, i) => {
    if(searchText.length > 2){
      this.props.getStreets(this.props.clientPhone, searchText, i)
    }    
  }

  onHouseSearch = (searchField, i) => {
    const house = searchField ? searchField : false
    this.props.getHouse(house, i)
  }

  onHouseSelect= (value, option) => {
    this.props.setHouse(option.props.label, option.props.iter, option.props.label)
    this.refsArr[option.props.nextFocus].focus()
  }

  addAddressTemplate = () => {
    const {nameTemplate, streetTemplate, buildingTemplate } = this.props.addAddress
    let isError = false


    if(buildingTemplate.length < 1){
      this.props.setErrorMsg('Не заполнено поле Дом')
      isError = true
    }

    if(streetTemplate.length < 3){
      this.props.setErrorMsg('Не заполнено поле Улица')
      isError = true
    }
    
    if(nameTemplate.length < 1){
      this.props.setErrorMsg('Не заполнено поле Название маршрута')
      isError = true
    }

    if(!isError){
      this.props.close(0)
      this.props.addAddressTemplate()
    }
  }
 
  handleKeyPress = (event, nextFocus) => {
    if(event.key === 'Enter'){
      if(nextFocus){
          this.refsArr[nextFocus].focus()
      }
    }
  }

  render() {
    const { addAddress, chgAddAddress, close } = this.props
    const {nameTemplate, streetTemplate, buildingTemplate, homeTemplate, templateInfo} = addAddress

    const dataSource = this.props.findedStreets[0].map( street => {
      const optionKey = `${street.namerus} ${street.id}`;
      return (<Option
        key={optionKey}
        streetid={street.id}
        label={street.namerus}
        streettype={street.streettype}
        geox={street.geox}
        geoy={street.geoy}
        nextFocus="buildingTemplate"
        iter={0}
      >
        {street.streettype === 0 ? street.namerus : street.namerus}
      </Option>)
    })
    
    const houseDataSource = this.props.findedHouses[0].map( house => {
      const optionKey = `${house.id} ${house.geox}`;
      return (<Option
        key={optionKey}
        houseid={house.id}
        label={house.value}
        geox={house.geox}
        geoy={house.geoy}
        nextFocus="homeTemplate"
        iter={0}
      >
        {house.value}
      </Option>)
    })

    return (
      <>
        <div className="add-address-form">
          <div className="row row-mp">
            <div className="col">
              <input type="text" className="form-control webcab-field" name="nameTemplate" value={nameTemplate} placeholder="Название маршрута" onChange={chgAddAddress} onKeyPress={ evt => this.handleKeyPress(evt, 'streetTemplate')} />
            </div>
          </div>
          <div className="row row-mp">
            <div className="col">
              <AutoComplete
                dataSource={dataSource}
                onSelect={this.onStreetSelect}
                onSearch={text => this.onStreetSearch(text, 0)}
                onChange={text => this.props.onChangeStreet(text, 0)}
                className="form-control webcab-field"
                placeholder="Улица *"
                value={streetTemplate}
                ref={ target => { this.refsArr.streetTemplate = target }}
              />
            </div>
          </div>
          <div className="row row-mp">
            <div className="col">
              <AutoComplete
                dataSource={houseDataSource}
                onSelect={this.onHouseSelect}
                onSearch={text => this.onHouseSearch(text, 0)}
                onChange={text => this.props.onChangeHouse(text, 0)}
                className="form-control webcab-field"
                disabled={this.props.isPOI[0]}
                placeholder="Дом *"
                value={buildingTemplate}
                ref={ target => { this.refsArr.buildingTemplate = target }}
              />
            </div>
            <div className="col">
              <input type="text" className="form-control webcab-field" name="homeTemplate" ref={ target => { this.refsArr.homeTemplate = target }} value={homeTemplate} placeholder="Подъезд" onChange={chgAddAddress} onKeyPress={ evt => this.handleKeyPress(evt, 'templateInfo')} />
            </div>
          </div>
          <div className="row row-mp">
            <div className="col">
              <textarea name="templateInfo" ref={ target => { this.refsArr.templateInfo = target }} className="form-control webcab-field" value={templateInfo} style={{ height: 100 }} onChange={chgAddAddress} placeholder="Примечание" onKeyPress={ evt => this.handleKeyPress(evt, 'addBtn')} />
            </div>
          </div>
        </div>
        <div className="add-address-controls">
          <button className="add-address-cancel" onClick={() => close(0)}></button>
          <button className="add-address-btn" onClick={this.addAddressTemplate}  ref={ target => { this.refsArr.addBtn = target }}>Добавить адрес</button>
        </div>
      </>
    )
  }
}

const withData = inject(stores => ({
  addAddress: stores.TemplatesStore.addAddress,
  chgAddAddress: stores.TemplatesStore.chgAddAddress,
  addAddressTemplate: stores.TemplatesStore.addAddressTemplate,
  findedStreets: stores.TemplatesStore.findedStreets,
  findedHouses: stores.TemplatesStore.findedHouses,
  isPOI: stores.TemplatesStore.isPOI,
  setStreet: stores.TemplatesStore.setStreet,
  setHouse: stores.TemplatesStore.setHouse,
  getStreets: stores.TemplatesStore.getStreets,
  onChangeStreet: stores.TemplatesStore.onChangeStreet,
  getHouse: stores.TemplatesStore.getHouse,
  onChangeHouse: stores.TemplatesStore.onChangeHouse,
  setErrorMsg: stores.NotificationsStore.setErrorMsg,
}))

export default withData(AddAddress)
